export default __webpack_public_path__ + "static/media/void_item.a96b8ebb.svg";